import { createApp } from 'vue';
// import VueRouter from 'vue-router';
import docReady from '../../../assets/js/docReady';
import store from './store/store';
import router from './router/router';

import mijnkeuze from "./mijnkeuze.vue";

docReady(() => {
    document.querySelectorAll('#mijnkeuze')
        .forEach((mountPoint) => {
            const mijnKeuzeApp = createApp(mijnkeuze);

            mijnKeuzeApp.use(store);
            mijnKeuzeApp.use(router);
            mijnKeuzeApp.mount(mountPoint);
        });
});
